export const scrollTo = ({ top, left, behavior = 'smooth' }: ScrollToOptions) => {
  if (document.documentElement) {
    // Old javascript contexts do not support `scrollTo`
    document.documentElement.scrollTo?.({ top, left, behavior });
  }
};
